import * as api from '@/api/works'
import * as types from '@/store/mutation-types/'

/**
 * @param  {Function} options.commit
 * @return {Promise}
 */
export const getWorks = ({ commit, rootState }) => {
  commit(types.LOADER, true)
  return new Promise((resolve, reject) => {
    api.get()
      .then((res) => {
        commit(types.LOADER, false)
        commit(types.WORKS_SUCCESS, res.data)
        resolve(res)
      })
      .catch((res) => {
        commit(types.FAIL, res.error_detail)
        commit(types.LOADER, false)
        reject(res)
      })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/works/actions.js